import { render, staticRenderFns } from "./PressQuotes.vue?vue&type=template&id=301a8aaf&lang=pug&"
import script from "./PressQuotes.vue?vue&type=script&lang=js&"
export * from "./PressQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports